var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar2Fill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_2_fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49700",
    "data-name": "Path 49700",
    d: "M24,0V24H0V0ZM12.594,23.258l-.012,0-.071.035-.02,0-.014,0-.071-.036a.022.022,0,0,0-.024.006l0,.01-.017.428.005.02.01.013.1.074.015,0,.012,0,.1-.074.012-.016,0-.017-.017-.427a.022.022,0,0,0-.016-.018m.264-.113-.014,0-.184.093-.01.01,0,.011.018.43.005.012.008.008.2.092a.025.025,0,0,0,.029-.008l0-.014-.034-.614a.027.027,0,0,0-.02-.022m-.715,0a.023.023,0,0,0-.027.006l-.006.014-.034.614a.025.025,0,0,0,.017.024l.015,0,.2-.093.01-.008,0-.011.018-.43,0-.012-.01-.01Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49701",
    "data-name": "Path 49701",
    d: "M16,3a1,1,0,0,1,1,1V5h2a2,2,0,0,1,2,2V19a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V7A2,2,0,0,1,5,5H7V4A1,1,0,0,1,9,4V5h6V4a1,1,0,0,1,1-1M8.01,16H8a1,1,0,0,0-.117,1.993L8.01,18a1,1,0,0,0,0-2m4,0H12a1,1,0,0,0-.117,1.993L12.01,18a1,1,0,0,0,0-2m4,0H16a1,1,0,0,0-.117,1.993L16.01,18a1,1,0,0,0,0-2m-8-4H8a1,1,0,0,0-.117,1.993L8.01,14a1,1,0,0,0,0-2m4,0H12a1,1,0,0,0-.117,1.993L12.01,14a1,1,0,0,0,0-2m4,0H16a1,1,0,0,0-.117,1.993L16.01,14a1,1,0,0,0,0-2M19,7H5V9H19Z",
    fill: "#4169e1",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2Fill);
export default __webpack_public_path__ + "static/media/calendar_2_fill.b2e988147f1b7593c6aee092aff009f8.svg";
export { ForwardRef as ReactComponent };